module.exports = "/images/vendor/flag-icon-css/flags/4x3/cr.svg?7b4ebd50f5274e5bfca82408ca79c32d";